import { render, staticRenderFns } from "./DevicesEdit.vue?vue&type=template&id=4c06096c&"
import script from "./DevicesEdit.vue?vue&type=script&lang=js&"
export * from "./DevicesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports